module.exports = __webpack_public_path__ + "img/index10.bffdc6a6.svg";